export { WidgetInfo, useWidget } from './WidgetInfo';
